import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import {
  TYPE_LABELS,
  formatNumber,
  DotsMenu,
  MobileActions,
} from "./tableUtils";
import { isDesktop } from "utils";

interface PreciousMetalsTableProps {
  transactions: InvestmentTransactionType[];
  item: any | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const PreciousMetalsTable = ({
  transactions,
  item,
  isOwn = false,
  onEditTx,
}: PreciousMetalsTableProps) => {
  if (!isDesktop()) {
    return (
      <div className="itm-mobile-list">
        {transactions.map((tx) => (
          <div key={tx.uuid} className="itm-mobile-card">
            <table className="side-modal__table">
              <tbody>
                <tr>
                  <td className="side-modal__table-label">Transakcja:</td>
                  <td className="side-modal__table-cell">
                    {TYPE_LABELS[tx.type] ?? tx.type}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Cena zakupu:</td>
                  <td className="side-modal__table-cell">
                    {formatNumber(tx.totalValue)}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Waluta:</td>
                  <td className="side-modal__table-cell">
                    {tx.currency?.short ?? "Brak"}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Masa:</td>
                  <td className="side-modal__table-cell">
                    {tx.quantity != null
                      ? `${tx.type === "buy" ? "+" : "-"}${tx.quantity}g`
                      : "Brak"}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Próba:</td>
                  <td className="side-modal__table-cell">
                    {item?.details?.fineness ?? "Brak"}
                  </td>
                </tr>
              </tbody>
            </table>
            <MobileActions
              tx={tx}
              onEdit={
                isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
              }
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <table className="itm-table">
      <thead>
        <tr>
          <th>Transakcja</th>
          <th>Cena zakupu</th>
          <th>Waluta</th>
          <th>Masa</th>
          <th>Próba</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatNumber(tx.totalValue)}</td>
            <td>{tx.currency?.short ?? "Brak"}</td>
            <td>
              {tx.quantity != null
                ? `${tx.type === "buy" ? "+" : "-"}${tx.quantity}g`
                : "Brak"}
            </td>
            <td>{item?.details?.fineness ?? "Brak"}</td>
            <td>
              <DotsMenu
                tx={tx}
                onEdit={
                  isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PreciousMetalsTable;
